import { ResponsiveImg } from "@/components/responsive-img";
import { imgSizes } from "@/lib/images";

export function ImageMarquee({ images }: { images: string[] }) {
  const row = [...images, ...images];
  return (
    <div className="relative overflow-hidden py-2" aria-hidden>
      <div className="animate-marquee flex w-max gap-5">
        {row.map((name, i) => (
          <div
            key={name + i}
            className="h-44 w-64 shrink-0 overflow-hidden rounded-lg shadow-[var(--shadow-soft)] md:h-56 md:w-80"
          >
            <ResponsiveImg
              name={name}
              sizes={imgSizes.marquee}
              alt=""
              loading="lazy"
              decoding="async"
              className="h-full w-full object-cover transition-transform duration-1000 hover:scale-105"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
